import { useCallback } from 'react';
import type { WorkflowProfile } from '@/lib/workflowTemplates';
import { useOnboarding } from '@/components/onboarding/useOnboarding';

export interface UseWizardHandlerDeps {
  setWizardOpen: (v: boolean) => void;
  setWorkflowProfile: (p: WorkflowProfile | null) => void;
  logAction: (action: string, detail?: string) => void;
}

/**
 * Memoized WorkflowWizardDialog.onComplete handler.
 * Bridges the existing wizard into the onboarding provider so the user's
 * template choice drives tool-labels and the TourPicker.
 */
export function useWizardHandler({
  setWizardOpen,
  setWorkflowProfile,
  logAction,
}: UseWizardHandlerDeps) {
  const { completeIntroFromTemplate } = useOnboarding();

  return useCallback((profile: WorkflowProfile | null) => {
    setWizardOpen(false);
    if (!profile) return;
    setWorkflowProfile(profile);
    logAction(
      'Wizard completed',
      profile.templateId === 'advanced' ? 'Advanced mode' : profile.templateId,
    );
    completeIntroFromTemplate(profile.templateId);
  }, [setWizardOpen, setWorkflowProfile, logAction, completeIntroFromTemplate]);
}
